import React from "react";

export const CryptoHourlyIcon = ( props: React.SVGProps<SVGSVGElement> ) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_17454_52633)">
            <path
                d="M8.00016 6.66536V1.33203C4.31826 1.33203 1.3335 4.3168 1.3335 7.9987C1.3335 11.6806 4.31826 14.6654 8.00016 14.6654C11.6821 14.6654 14.6668 11.6806 14.6668 7.9987"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.99984 9.33464C8.7362 9.33464 9.33317 8.73767 9.33317 8.0013C9.33317 7.26494 8.7362 6.66797 7.99984 6.66797C7.26347 6.66797 6.6665 7.26494 6.6665 8.0013C6.6665 8.73767 7.26347 9.33464 7.99984 9.33464Z"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_17454_52633">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
